import {
  CURRENT_COMPANY_ID_HEADER_KEY,
  SILENT_REQUEST_HEADER_KEY,
} from "@hd/http-client/constants";
import httpClient from "@hd/http-client/http-client";
import { useQuery } from "@tanstack/react-query";

type QueryParams = {
  companyId: number | null;
};

const apiUrl = () => `/realtimeconnection/online-contact-ids`;

const fetchData = async (params: QueryParams): Promise<number[]> => {
  const result = await httpClient.get<number[]>(
    import.meta.env.VITE_HD_API_URL + apiUrl(),
    {
      headers: {
        [SILENT_REQUEST_HEADER_KEY]: "true",
        [CURRENT_COMPANY_ID_HEADER_KEY]: params.companyId,
      },
    }
  );

  return result.data;
};

export const onlineContactIdsQueryKey = (params: QueryParams) => [
  apiUrl(),
  params,
];

export const useOnlineContactIdsQuery = (params: QueryParams) => {
  return useQuery({
    // staleTime: 10000 * 60,
    queryKey: onlineContactIdsQueryKey(params),
    queryFn: () => fetchData(params),
    enabled: !!params.companyId,
  });
};
